import env from '../env.json'
import { store } from '../app/store'
import { errorCodes } from './errormessages'
import { INTERNAL_SERVER_ERROR, LOGOUT, NETWORK_ERROR, REFRESH_TOKEN_SUCCESS } from '../app/authState'
import { isObject } from './common'
import { sendCustomSentryError, sendCustomSentryMessage } from './sentryUtility'

const baseHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Origin: '*',
}

// @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
let isFirstRequestFinished = null
// @ts-expect-error TS7034 -- MIGRATION: not approved, fix when encountered
let requestsForDelayList = []
let isTokenError = false

export async function apiCall(
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  api,
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  method,
  auth = null,
  body = null,
  types = null,
  withBase = null,
  headers = null,
  attempt = 0,
  isBlob = false,
  isDelayRequest = false,
) {
  if (
    !isDelayRequest &&
    // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
    isFirstRequestFinished === false &&
    api !== 'api/v1/auth/refreshtoken' &&
    store.getState().auth.loggedIn
  ) {
    requestsForDelayList.push({ api, method, auth, body, types, withBase, headers, attempt, isBlob })
    return
  }
  // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
  if (isFirstRequestFinished === null) {
    isFirstRequestFinished = false
  }
  return new Promise((resolve, reject) => {
    let baseAPI = ''
    let requestHeaders = {}
    let response = ''
    if (withBase) {
      baseAPI = withBase
    } else {
      baseAPI = env.baseURL
    }
    if (!auth) {
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      auth = { Authorization: `Bearer ${store.getState().auth.accessToken}` }
    }
    if (headers) {
      // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
      requestHeaders = { ...headers, ...auth }
    } else {
      // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
      requestHeaders = { ...baseHeaders, ...auth }
    }
    if (types && !store.getState().auth.isConnected) {
      isFirstRequestFinished = null
      setTimeout(() => {
        store.dispatch({
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          type: types.error,
          payload: { UserFriendlyErrorCode: errorCodes.NO_CONNECTION },
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          extraData: types.extraData,
          failed: true,
        })
        store.dispatch({
          type: NETWORK_ERROR,
          failed: true,
        })
      }, 600)
      return
    }
    fetch(baseAPI + api, { method, headers: requestHeaders, body })
      .then(async (res) => {
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        response = res
        try {
          if (isBlob && res.ok) {
            return res.blob()
          }
          if (res.ok && method === 'PUT') {
            const data = await res.json()
            if (data) {
              return { success: true, data }
            }
            return { success: true }
          }
          if (res.status === 401) {
            isTokenError = true
            try {
              // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
              if (Object.keys(auth).length !== 0) {
                refreshTokens(() => {
                  apiCall(api, method, null, body, types, null, headers, attempt, isBlob)
                })
                return Promise.reject({ error: 'Cancel' })
              }
            } catch (e) {
              if (types) {
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                store.dispatch({ type: types.error, payload: e, failed: true })
              } else {
                return Promise.reject({ ErrorCode: 'Unauthorized' })
              }
            }
          }
          return res.text().then((text) =>
            res.ok ?
              text ? JSON.parse(text)
              : { success: true }
            : text ?
              Promise.reject({
                // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                ...JSON.parse(text),
                status: res.status,
                message: res.statusText,
              })
            : Promise.reject({
                status: res.status,
                message: res.statusText,
              }),
          )
        } catch (e) {
          return res.text().then((text) => (res.ok ? text : Promise.reject(text)))
        }
      })
      .then((currentResponse) => {
        // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
        if (isFirstRequestFinished === false) {
          isFirstRequestFinished = true
        }
        setTimeout(() => {
          if (requestsForDelayList.length) {
            // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
            requestsForDelayList.forEach((config, idx, array) => {
              apiCall(
                config.api,
                config.method,
                config.auth,
                config.body,
                config.types,
                config.withBase,
                config.headers,
                config.attempt,
                config.isBlob,
                true,
              )
              if (idx === array.length - 1) {
                isFirstRequestFinished = null
                requestsForDelayList = []
                isTokenError = false
              }
            })
          } else {
            isFirstRequestFinished = null
            isTokenError = false
          }
        }, 150)
        localStorage.removeItem('isRefreshingToken')
        if (types) {
          // @ts-expect-error TS2525 -- MIGRATION: not approved, fix when encountered
          const { success, successAction } = isObject(types.success) ? types.success : { success: types.success }

          store.dispatch({
            type: success,
            payload: currentResponse,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            extraData: types.extraData,
            failed: false,
          })

          if (successAction) {
            store.dispatch({
              type: successAction,
              payload: true,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              extraData: types.extraData,
              failed: false,
            })
          }

          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          if (types.callAPI) {
            setTimeout(() => {
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              types.callAPI()
            }, 800)
          }
        } else {
          resolve(currentResponse)
        }
      })
      .catch((e) => {
        sendCustomSentryError({
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          message: e.message || 'An unknown error occurred',
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          name: e.ErrorCode,
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          status: e.status,
        })
        if (requestsForDelayList.length) {
          if (!isTokenError) {
            setTimeout(() => {
              // @ts-expect-error TS7005 -- MIGRATION: not approved, fix when encountered
              requestsForDelayList.forEach((config, idx, array) => {
                apiCall(
                  config.api,
                  config.method,
                  config.auth,
                  config.body,
                  config.types,
                  config.withBase,
                  config.headers,
                  config.attempt,
                  config.isBlob,
                  true,
                )
                if (idx === array.length - 1) {
                  isFirstRequestFinished = null
                  requestsForDelayList = []
                }
              })
            }, 150)
          }
        } else {
          isFirstRequestFinished = null
        }
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        if (e.status === 512 || e.message === 'Failed to fetch') {
          if (types) {
            store.dispatch({
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              type: types.error,
              payload: { UserFriendlyErrorCode: 512 },
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              extraData: types.extraData,
            })
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            if (types.callAPI) {
              setTimeout(() => {
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                types.callAPI()
              }, 800)
            }
          } else {
            reject(e)
          }
          return
        }
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        if (e.message === 'Load failed') {
          setTimeout(() => {
            store.dispatch({
              // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
              type: types.error,
              failed: true,
              payload: {
                UserFriendlyErrorCode: errorCodes.NO_CONNECTION,
                api,
                body,
              },
            })
            store.dispatch({
              type: NETWORK_ERROR,
              failed: true,
            })
          }, 600)
          return
        }
        if (!navigator.onLine && types) {
          setTimeout(() => {
            store.dispatch({
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              type: types.error,
              failed: true,
              payload: {
                UserFriendlyErrorCode: errorCodes.NO_CONNECTION,
                api,
                body,
              },
            })
            store.dispatch({
              type: NETWORK_ERROR,
              failed: true,
              payload: { api, body },
            })
          }, 600)
          return
        }
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (response.status === 200) {
          if (types) {
            // @ts-expect-error TS2525 -- MIGRATION: not approved, fix when encountered
            const { success, successAction } = isObject(types.success) ? types.success : { success: types.success }

            store.dispatch({
              type: success,
              failed: false,
              payload: { success: true },
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              extraData: types.extraData,
            })

            if (successAction) {
              store.dispatch({
                type: successAction,
                payload: true,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                extraData: types.extraData,
                failed: false,
              })
            }

            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            if (types.callAPI) {
              setTimeout(() => {
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                types.callAPI()
              }, 800)
            }
          } else {
            resolve({ success: true })
          }
          return
        }
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        if (types && e.error !== 'Cancel') {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          if (e.ErrorCode === 'InternalServerError') {
            store.dispatch({
              type: INTERNAL_SERVER_ERROR,
              failed: true,
              // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
              payload: { ...e, api, body },
            })
          }
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          if (types.error === LOGOUT) {
            sendCustomSentryMessage('Logout, refresh token failed')
          }
          store.dispatch({
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            type: types.error,
            failed: true,
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            payload: { ...e, api, body },
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            extraData: types.extraData,
          })
        } else {
          reject(e)
        }
      })
  })
}

const JWTRefreshObject = () => {
  const jwt = store.getState().auth.accessToken
  if (jwt) {
    return {
      AccessToken: jwt,
    }
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const refreshTokens = async (callBack, isRetry = false) => {
  const isTokenRefreshing = localStorage.getItem('isRefreshingToken')

  if (JWTRefreshObject()) {
    if (isRetry) {
      callBack()
      return
    }
    if (isTokenRefreshing) {
      setTimeout(() => {
        refreshTokens(callBack, true)
      }, 1000)
      return
    }

    try {
      localStorage.setItem('isRefreshingToken', JSON.stringify('true'))
      const refreshObject = JSON.stringify(JWTRefreshObject())
      const refreshEndPoint = 'api/v1/auth/refreshtoken'
      await apiCall(
        refreshEndPoint,
        'POST',
        null,
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        refreshObject,
        {
          success: REFRESH_TOKEN_SUCCESS,
          error: LOGOUT,
          callAPI: callBack,
        },
        env.baseURL,
      )
    } catch (e) {
      localStorage.removeItem('isRefreshingToken')

      return Promise.reject({ ErrorCode: 'Unauthorized' })
    } finally {
      localStorage.removeItem('isRefreshingToken')
    }
  }
}
